<template>
  <v-app id="inspire">
    <v-navigation-drawer
            v-if="isUserLoggedIn"
            v-model="drawer"
            clipped
            temporary
            app
    >
      <v-list dense>
        <v-list-item v-for="link of links"
                     :key="link.title"
                     :to="link.url"
        >
          <v-list-item-content>
            <v-list-item-title v-text="link.title"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="user_role == 'admin' || user_role == 'manager'">
          <v-list-item-content>
            <v-list-item-title>Alerts [{{newMessagesCount}}]</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/home">
          <v-list-item-content>
            <v-list-item-title>{{user.firstName}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="onLogout">
          <v-list-item-content>
            <v-list-item-title>Log Out</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
            text
            app
            color="primary"
            class="header-menu"
    >
      <v-app-bar-nav-icon
              v-if="isUserLoggedIn"
              @click.stop="drawer = !drawer"
              class="hidden-md-and-up"
      ></v-app-bar-nav-icon>

      <div class="logo-container">
        <v-img class="logo"></v-img>
      </div>

      <v-toolbar-items class="hidden-sm-and-down" v-if="isUserLoggedIn">
        <v-btn depressed color="primary" v-for="link of links" :key="link.title" :to="link.url">{{ link.title }}</v-btn>
        <!-- Drivershare Dropdown -->
        <v-menu v-if="user_role == 'admin' || user_role == 'manager'" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn depressed color="primary" v-bind="attrs" v-on="on"> Drivershare <v-icon right
                small>mdi-menu-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item :to="{ name: 'RestaurantGroup' }" router>
              <v-list-item-title>Restaurant Groups</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'DriverShareSchedule' }" router>
              <v-list-item-title>Schedule</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name:'DriverShareTimesheet'}" router>
              <v-list-item-title>Timesheet</v-list-item-title>
            </v-list-item>
            <v-list-item to="/drivershare-other-page" router>
              <v-list-item-title>Invoice</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-spacer></v-spacer>

        <alerts-dropdown-menu v-if="user_role == 'admin' || user_role == 'manager'"></alerts-dropdown-menu>

        <v-btn depressed
               color="primary"
               to="/options"
               class="float-right options"
               v-if="user_role == 'admin' || user_role == 'manager'"
        ><v-icon>mdi-settings</v-icon></v-btn>

        <v-btn depressed
               color="primary"
               to="/users"
               class="float-right"
               v-if="user_role == 'admin'"
        ><v-icon>mdi-shield-account</v-icon></v-btn>

        <v-btn depressed
               color="primary"
               to="/home"
               class="float-right users"
        >{{user.firstName}}</v-btn>
        <v-btn depressed
               color="primary"
               class="logout-btn users float-right"
               @click="onLogout"
        ><v-icon left>mdi-logout</v-icon>Log Out</v-btn>
      </v-toolbar-items>

      <v-toolbar-items class="hidden-sm-and-down" v-if="!isUserLoggedIn">
        <v-spacer></v-spacer>
        <v-btn depressed
               color="primary"
               class="logout-btn users float-right"
               @click="onBackToWebsite"
        ><v-icon left>mdi-home</v-icon>Back to website</v-btn>
      </v-toolbar-items>

    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>

    <template v-if="error">
      <v-snackbar
              :multi-line="true"
              :timeout="5000"
              @input="closeError"
              :value="true"
      >
        {{ error }}
        <v-btn
                small
                color="warning"
                text
                @click="closeError"
        ><v-icon left>mdi-close-circle</v-icon>
          Close
        </v-btn>
      </v-snackbar>
    </template>

  </v-app>
</template>

<script>
import {mapGetters} from 'vuex'
import { STATUS_NEW } from './store/alerts'
import * as _ from 'lodash';

const ROLE_ADMIN = 10;
const ROLE_MANAGER = 20;

export default {
  name: 'App',
  mounted: function(){
    let user = JSON.parse(localStorage.getItem("user"));
    this.$store.commit('setUser',user);
    if (user && parseInt(user.role) == ROLE_ADMIN) {
      this.links.push(
        {title: 'Schedule', url: '/schedule'},
        {title: 'Timesheets', url: '/timesheet'},
        {title: 'Invoices', url: '/invoices'},
        {title: 'News Feed', url: '/newsfeed'},
        {title: 'Drivers', url: '/drivers'},
        {title: 'Restaurants', url: '/restaurants'},
        {title: 'Areas', url: '/areas'},
        {title: 'Reporting', url: '/reporting'},
      );

      this.$data.user_role = 'admin';
      this.setupSocket();
    }

    if (user && parseInt(user.role) ==  ROLE_MANAGER) {
      this.links.push(
        {title: 'Schedule', url: '/schedule'},
        {title: 'Timesheets', url: '/timesheet'},
        {title: 'Invoices', url: '/invoices'},
        {title: 'News Feed', url: '/newsfeed'},
        {title: 'Reporting', url: '/reporting'},
      );

      this.$data.user_role = 'manager';
      this.setupSocket();
    }

    if (user && user.role == 'restaurant') {
      this.links.push(
        {title: 'Schedule', url: '/schedulerestaurant'},
        {title: 'Timesheets', url: '/timesheetrestaurant'},
        {title: 'Invoices', url: '/invoicesrestaurant'},
      );

      this.setupSocket();
    }

    if(this.$router.currentRoute.path == '/') { // default route news feed
      this.$router.push('/newsfeed')
    }
  },
  data: () => ({
      drawer: null,
      links: [],
      user_role: void 0
  }),
      computed: {
          ...mapGetters({
              user: 'user',
              error: 'error',
              isUserLoggedIn: 'isUserLoggedIn',
              loading: 'loading',
              alert_list: 'alerts',
          }),
          newMessagesCount() {
              if (_.isEmpty(this.alert_list)) {
                return 0;
              }

              return _.sumBy(this.alert_list, p => Number(p.status == STATUS_NEW));
          }
      },
    // created(){
    //
    // },
  /*updated(){
      if (this.$route.query['loginError']) {
          this.$router.push('/registration')
      }
  },*/
    methods: {
        closeError() {
            this.$store.dispatch('clearError')
        },
        onLogout() {
            this.$store.dispatch('logOutUser')
            this.$router.push('/login')
        },
        setupSocket() {
          this.$store.dispatch('setupSocketConnection');
        },
        onBackToWebsite() {
          window.location = 'https://www.dreamdrivers.co.uk/';
        }
    }
};
</script>

<style>
.dialog-closeBtn {
    position: absolute;
    top: 4px;
    font-family: -webkit-pictograph;
    right: 14px;
    font-size: 29px;
    opacity: .5;
    z-index: 1000;
    cursor: pointer;
}

.dialog-card_body {
    padding: 0 0 20px !important;
}

.hide-time-picker-indicator input[type="time"]::-webkit-calendar-picker-indicator {
  background: none;
  display:none;
}
.pointer {
  cursor: pointer;
}

.tool-bar__totals-panel {
  margin-left: 260px;
}

.tool-bar__totals-panel .v-toolbar__content {
  padding-left: 6px;
  padding-top: 2px;
  padding-right: 6px;
}

.bottom-panel__totals {
  position: fixed;
  bottom: 0;
  z-index: 5;
  width: 100%;
  margin-left: -11px;
  margin-bottom: -6px;
}

.shift-button_item {
  margin-top: 2px;
}

.shift-button_item .v-btn__content {
  display: block;
}

/** Timesheet admin and restaurant */
.tool-bar__timesheet-form-fixed {
  margin-left: 261px;
  margin-right: 5px;
}

.tool-bar__timesheet-form .v-toolbar__content {
  padding: 0px;
  align-items: flex-start;
  width: 100%;
}
/** /- Timesheet admin and restaurant */
</style>

<style lang="less">
  @import "assets/style.less";
  @import "assets/fonts.less";
</style>
